<template>
  <div class="onboarding-datatable">
    <material-card
      :title="title"
      :text="`Attestation Accounts`"
      color="orange">
      <v-layout
        row
        wrap
        align-center>
        <v-flex md4>
          <v-text-field
            v-model="search"
            label="Search"
            solo
            outlined
            append-icon="search"
            hide-details
          />
        </v-flex>
        <v-flex md3>
          <v-select
            v-model="statusFilter"
            :items="['All', 'Pending', 'Approved', 'Reject']"
            item-text="text"
            item-value="value"
            hide-details
            attach
            label="Status"
          />
        </v-flex>
        <v-flex md3>
          <v-layout
            row
            align-center>
            <label class="mb-1">Type: &nbsp;</label>
            <v-radio-group
              v-model="attestationType"
              row>
              <v-radio
                label="Single"
                value="Single"/>
              <v-radio
                label="Bulk"
                value="Bulk"/>
            </v-radio-group>
          </v-layout>
        </v-flex>
        <v-flex align-self-center>
          <div style="text-align: right">
            <v-btn>Download Report</v-btn>
          </div>
        </v-flex>
      </v-layout>
      <v-progress-linear
        v-slot:progress
        v-if="loadingRequest"
        color="orange"
        indeterminate/>
      <v-data-table
        ref="accountList"
        :headers="accountHeaders"
        :items="filteredAccounts"
        :search="search"
        :pagination.sync="pagination"
        :rows-per-page-items="rowsPerPageItems"
        class="accounts-table"
        loading
        loading-text="Loading... Please wait"
        fixed-header
        item-key="Acct_ID"
      >
        <template
          slot="headerCell"
          slot-scope="{ header }">
          <span
            class="subheading font-weight-light text-success text-md-left text--darken-3"
            v-text="header.text"
          />
        </template>
        <template v-slot:items="props">
          <tr :active="props.selected">
            <td title="Account ID">
              <a href="javascript:void(0)" @click="$router.push({ path: '/admin/attestations/view-requests/' + props.item.Acct_ID })">{{ props.item.Acct_ID }}</a>
            </td>
            <td title="Status">
              <v-chip
                :color="statusBgColor(props.item.Status)"
                :text-color="statusTextColor(props.item.Status)">{{ props.item.Status }}</v-chip>
            </td>
            <td title="Account Owner">{{ props.item.Acct_Owner }}</td>
            <td title="WBS Code">{{ props.item.WBS_Code }}</td>
            <td title="Managed Services">{{ props.item.Managed_Services }}</td>
            <td title="Internal_Vs_Saas">{{ props.item.Internal_Vs_Saas }}</td>
            <td title="Direct_Vs_Indirect_Access">{{ props.item.Direct_Vs_Indirect_Access }}</td>
            <td title="New_Workload">{{ props.item.New_Workload }}</td>
            <td title="SFDC ID">{{ props.item.SFDC_ID }}</td>
            <td title="DXC_Services">{{ props.item.DXC_Services }}</td>
            <td title="Requestor">{{ props.item.Requestor_Email }}</td>
            <td title="Created At">{{ dateToLocal(props.item.Created_At) }}</td>
            <td title="Updated At">{{ dateToLocal(props.item.Updated_At) }}</td>
          </tr>
        </template>
      </v-data-table>
    </material-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { convertUTCToLocal } from '@/utils/helper'
export default {
  props: ['type', 'title'],
  data () {
    return {
      search: '',
      statusFilter: 'All',
      attestationType: 'Single',
      selected: [],
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 15,
        totalItems: 0
      },
      rowsPerPageItems: [5, 10, 15, {"text":"$vuetify.dataIterator.rowsPerPageAll","value":-1}]
    }
  },
  computed: {
    ...mapState('admin/accountAttestation', ['attestationAccounts', 'accountHeaders', 'loadingRequest']),
    filteredAccounts () {
      return this.attestationAccounts
    },
    updatedAt() {
      return convertUTCToLocal(this.request.Updated_At)
    },
    createdAt() {
      return convertUTCToLocal(this.request.Created_At)
    }
  },
  mounted () {
    this.$store.dispatch('admin/accountAttestation/getAllAccountAttestations')
  },
  beforeDestroy () {
    this.$store.commit('admin/accountOnboarding/clearViewRequestData')
  },
  methods: {
    statusBgColor(status) {
      switch (status) {
        case 'Not Submitted':
          return '#2ecc71'
        case 'Approved':
          return '#3498db'
        case 'Pending':
          return '#b7cdce'
        case 'Rejected':
          return '#FF5733'
        default:
          return '#fff'
      }
    },
    statusTextColor(status) {
      return status === 'Pending' ? '#000' : '#fff'
    },
    onEditAccount (record) {
      console.log('emit update')
      this.$emit('update', record)
    },
    dateToLocal (date) {
      return convertUTCToLocal(date)
    }
  }
}
</script>

<style lang="scss" scoped>
.cropped-string-users.none,
.full-string-users.none{
  display: none;
}
.onboarding-status-filter {
  text-align: right;
}
.expand-string {
  font-size: 26px !important;
  line-height: 15px;
  cursor: pointer;
}
.onboarding-status-filter-checkbox {
  display: inline-block;
}
</style>